import { Link } from 'react-router-dom'

/** 404 der Editor-Konsole (außerhalb der Shell) — BMC-Designsystem `console.css`. */
export function EditorNotFound() {
  return (
    <div className="app">
      <main className="canvas">
        <div className="wrap-narrow">
          <section className="panel">
            <div className="empty">
              <div className="eyebrow">404</div>
              <div className="etitle" style={{ marginTop: '6px' }}>
                Seite nicht gefunden
              </div>
              <p>Diese Editor-Seite existiert nicht.</p>
              <Link to="/editor" className="btn outline" style={{ marginTop: '14px' }}>
                Zur Startseite
              </Link>
            </div>
          </section>
        </div>
      </main>
    </div>
  )
}
